import { render, staticRenderFns } from "./LayoutsCombinigAssetsCroppedPhotosSection.vue?vue&type=template&id=dd3c6068"
import script from "./LayoutsCombinigAssetsCroppedPhotosSection.vue?vue&type=script&lang=ts"
export * from "./LayoutsCombinigAssetsCroppedPhotosSection.vue?vue&type=script&lang=ts"
import style0 from "./LayoutsCombinigAssetsCroppedPhotosSection.vue?vue&type=style&index=0&id=dd3c6068&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports